import type { QueryClient } from "@tanstack/react-query";
import { updateDocumentLists } from "web_myplann/Api/Document/updateDocumentLists";

export const renameDocumentInCache = (
	queryClient: QueryClient,
	id: number,
	title: string,
) =>
	updateDocumentLists(queryClient, (list) => ({
		...list,
		documents: list.documents.map((document) =>
			document.id === id ? { ...document, title } : document,
		),
	}));
